import omit from 'lodash/omit';
import { useNavigate } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import IconPlus from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';

import FindPatientForm from '../patients/FindPatientForm';

export const SortButton = () => {
  return <></>;
};

const CaseFilters = props => {
  const navigate = useNavigate();
  return (
    <Stack direction='row' spacing={{xs: 1.25, md: 3.65}} paddingTop={1.5} paddingBottom={1.5} fullWidth>
        <Stack direction='row' justifyContent='space-between' spacing={1}>
          <Box style={{minWidth: '200px'}}>
            <FindPatientForm
              rounded={true}
              defaultValue={props.filters?.patient_id}
              allPatients={false}
              fullWidth={true}
              color='primary'
              onSubmit={({patientId}) => {
                let _filters = (
                  patientId
                  ? {...props.filters, patient_id: patientId}
                  : omit(props.filters, 'patient_id')
                );
                props.onFilterChange(_filters);
              }}
            />
          </Box>
        </Stack>
        <Stack direction='row' spacing={2}>
          <Button
            variant='outlined'
            size='small'
            onClick={() => navigate('/providers/cases/new')}
          >
            <IconPlus />
            <span style={{marginLeft: '0.25em'}}>Create Case</span>
          </Button>
        </Stack>
    </Stack>
  );
};

export default CaseFilters;